export default {
	about: 'About',
	mission: 'Our Mission',
	vesion: 'Our Vesion'
}